// extracted by mini-css-extract-plugin
export default {"delete_btn":"styles_delete_btn__1Jgiz"};